import { Link } from "react-router";

import { InitialsTile } from "../lib/InitialsTile.tsx";
import type { OrgCard } from "./shell.model.ts";

/**
 * The firm this workspace IS, at the top of the rail.
 *
 * Above the nav rather than beside the identity card at the foot, because it
 * answers a different question. The card at the foot says who is reading; this
 * says whose workspace they are reading it in — and a member of an advisory
 * holds a mandate through the FIRM, not personally, so the firm is the subject
 * of every screen below it.
 *
 * The tick and the word are the same pair the identity card carries, and for
 * the same reason: on a registry whose product is verification, an unverified
 * entity showing no tick and no words is indistinguishable from a rendering
 * fault. The flag is the ORGANISATION's own — a verified advisor at an
 * unverified firm must not make the firm look checked.
 *
 * `kind` is the org type in small caps — "ADVISORY". It is here because two
 * firms can share a name and the type is what says which door this is; it is
 * the same fact `roleForOrgType` maps to a capacity, shown rather than implied.
 */
export function PortalOrgCard({ org }: { org: OrgCard }) {
  return (
    <Link className="shell__org" to={org.href}>
      <InitialsTile initials={org.initials} className="shell__org-initials" />
      <span className="shell__org-body">
        <span className="shell__org-name">{org.name}</span>
        <span className="shell__org-line">
          <span className="shell__org-kind">{org.kind}</span>
          <span
            className={`shell__org-verified${
              org.verified ? " shell__org-verified--yes" : ""
            }`}
          >
            {org.verifiedLabel}
            {org.verified && (
              <span aria-hidden="true" className="shell__org-tick">
                ✓
              </span>
            )}
          </span>
        </span>
      </span>
    </Link>
  );
}
